/* 928sRus — native kit options block
 *
 * Handles live kit pricing and adds the kit plus every selected part to the cart
 * as one grouped set of line items. Replaces the paid options apps.
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var decimal = parts[1];

    return (format || '${{amount}}').replace(
      /\{\{\s*(\w+)\s*\}\}/g,
      function (match, name) {
        switch (name) {
          case 'amount':
          case 'amount_with_comma_separator':
            return whole + '.' + decimal;
          case 'amount_no_decimals':
          case 'amount_no_decimals_with_comma_separator':
            return whole;
          default:
            return whole + '.' + decimal;
        }
      }
    );
  }

  function KitOptions(root) {
    this.root = root;
    this.form = root.closest('form[action*="/cart/add"]') || root.closest('form');
    this.moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    this.kitTitle = root.getAttribute('data-kit-title') || '';
    this.kitVariant = root.getAttribute('data-kit-variant');
    this.baseCents = parseInt(root.getAttribute('data-kit-base-cents'), 10) || 0;
    this.totalEl = root.querySelector('[data-kit-total]');
    this.errorEl = root.querySelector('[data-kit-error]');
    this.submitting = false;

    this.bind();
    this.updateTotal();
    this.unlockButton();
  }

  /* The snippet locks Add to Cart until this script is running, so that a
     failed asset load can never post the $0 kit line on its own. */
  KitOptions.prototype.unlockButton = function () {
    var button = this.form && this.form.querySelector('[name="add"]');
    if (button && button.getAttribute('data-kit-locked')) {
      button.disabled = false;
      button.removeAttribute('data-kit-locked');
    }
  };

  KitOptions.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('change', function (event) {
      if (event.target.classList.contains('kit-choice')) {
        self.clearError();
        self.updateTotal();
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        self.addToCart();
      });
    }
  };

  /* Every line this kit will put in the cart: included parts, the chosen
     dropdown options, and any ticked add-ons. */
  KitOptions.prototype.lines = function () {
    var lines = [];

    Array.prototype.forEach.call(
      this.root.querySelectorAll('.kit-included-line'),
      function (el) {
        lines.push({
          variant: el.getAttribute('data-variant'),
          qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
          cents: parseInt(el.getAttribute('data-cents'), 10) || 0,
          label: el.getAttribute('data-label'),
          role: 'Included'
        });
      }
    );

    Array.prototype.forEach.call(
      this.root.querySelectorAll('select.kit-choice'),
      function (select) {
        var option = select.options[select.selectedIndex];
        /* "none" = a deliberate None choice under a placeholder: adds nothing. */
        if (!option || !option.value || option.value === 'none') return;
        lines.push({
          variant: option.value,
          qty: parseInt(option.getAttribute('data-qty'), 10) || 1,
          cents: parseInt(option.getAttribute('data-cents'), 10) || 0,
          label: option.getAttribute('data-label'),
          role: 'Kit option',
          /* Which dropdown it came from, so two dropdowns picking the same part
             (e.g. left and right core on a pair) stay two separate cart lines. */
          group: select.getAttribute('data-group')
        });
      }
    );

    Array.prototype.forEach.call(
      this.root.querySelectorAll('input.kit-choice:checked'),
      function (input) {
        lines.push({
          variant: input.getAttribute('data-variant'),
          qty: parseInt(input.getAttribute('data-qty'), 10) || 1,
          cents: parseInt(input.getAttribute('data-cents'), 10) || 0,
          label: input.getAttribute('data-label'),
          role: 'Add-on'
        });
      }
    );

    return lines;
  };

  /* True when a required (placeholder) dropdown was answered with "None". */
  KitOptions.prototype.choseNone = function () {
    return !!this.root.querySelector('select[data-kit-required] option[value="none"]:checked');
  };

  KitOptions.prototype.kitQuantity = function () {
    if (!this.form) return 1;
    var field = this.form.querySelector('input[name="quantity"]');
    var qty = field ? parseInt(field.value, 10) : 1;
    return qty > 0 ? qty : 1;
  };

  KitOptions.prototype.updateTotal = function () {
    var total = this.baseCents;

    this.lines().forEach(function (line) {
      total += line.cents;
    });

    if (this.totalEl) {
      this.totalEl.textContent = formatMoney(total, this.moneyFormat);
    }

    /* Keep the theme's headline price in step with the configuration. */
    var headline = document.querySelector('.product-price .price-money');
    if (headline) {
      headline.textContent = formatMoney(total, this.moneyFormat);
    }

    return total;
  };

  KitOptions.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  };

  KitOptions.prototype.clearError = function () {
    if (!this.errorEl) return;
    this.errorEl.hidden = true;
  };

  KitOptions.prototype.addToCart = function () {
    if (this.submitting) return;

    this.clearError();

    /* Block the add if a required group has nothing available to pick. */
    if (this.root.querySelector('[data-kit-required-missing]')) {
      this.showError(
        'One of the parts in this kit is currently unavailable, so the kit cannot be ordered as configured. Please contact us and we will sort it out.'
      );
      return;
    }

    /* A dropdown with a placeholder (e.g. the core charge) must be chosen on
       purpose — it never defaults. */
    var unchosen = null;
    Array.prototype.forEach.call(
      this.root.querySelectorAll('select[data-kit-required]'),
      function (select) {
        if (!unchosen && !select.value) unchosen = select;
      }
    );
    if (unchosen) {
      var what = unchosen.getAttribute('data-kit-title') || 'an option';
      this.showError(
        'Please select the ' + what + ' before adding to your cart. See the description for more information.'
      );
      if (unchosen.scrollIntoView) unchosen.scrollIntoView({ behavior: 'smooth', block: 'center' });
      unchosen.focus();
      return;
    }

    /* A $0 kit whose parts are all optional must still have something chosen,
       or the bare $0 kit line would go to the cart on its own. A product with
       its own price (e.g. L1064 with "None") can be added on its own. */
    if (this.lines().length === 0 && this.baseCents === 0) {
      this.showError('Please choose at least one part before adding this kit to your cart.');
      return;
    }

    var self = this;
    var kitQty = this.kitQuantity();
    var uid = 'kit-' + Date.now() + '-' + Math.floor(Math.random() * 10000);

    var kitProps = { _kit_uid: uid, _kit_role: 'Kit' };
    /* Tells the cart guard the customer chose "None", so no core line is expected. */
    if (this.choseNone()) kitProps._kit_none = '1';

    var payload = [
      {
        id: Number(this.kitVariant),
        quantity: kitQty,
        properties: kitProps
      }
    ];

    this.lines().forEach(function (line) {
      var lineProps = {
        Kit: self.kitTitle,
        _kit_uid: uid,
        _kit_role: line.role
      };
      if (line.group) lineProps._kit_group = line.group;
      payload.push({
        id: Number(line.variant),
        quantity: line.qty * kitQty,
        properties: lineProps
      });
    });

    this.submitting = true;
    var button = this.form && this.form.querySelector('[name="add"]');
    var buttonText = button ? button.innerHTML : null;
    if (button) {
      button.setAttribute('disabled', 'disabled');
      button.innerHTML = 'Adding…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (error) {
        self.submitting = false;
        if (button) {
          button.removeAttribute('disabled');
          if (buttonText !== null) button.innerHTML = buttonText;
        }
        var message =
          (error && (error.description || error.message)) ||
          'Sorry — something went wrong adding this kit to your cart. Please try again.';
        self.showError(message);
      });
  };

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-kit-options]'),
      function (root) {
        if (root.dataset.kitReady) return;
        root.dataset.kitReady = 'true';
        new KitOptions(root);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();